// Run all queued callbacks and flush the queue.
// This method works in conjunction with hook `useSafe2FACallback()`
export async function runAllTwoFactorCallbacks() {
    window.twoFactorCallbackQueue.forEach((callbackItem) => {
        callbackItem.callback(callbackItem.args);
    });

    window.twoFactorCallbackQueue = [];
}
